import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var MiniCart = /** @class */ (function (_super) {
    tslib_1.__extends(MiniCart, _super);
    function MiniCart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.codeWasCopied = false;
        _this.codeWasCopiedTimer = null;
        return _this;
    }
    MiniCart.prototype.close = function () {
        this.$ui.minicartVisible = false;
    };
    MiniCart.prototype.copyCode = function () {
        var codeInput = this.$refs.planCode;
        codeInput.select();
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        this.codeWasCopied = true;
        clearTimeout(this.codeWasCopiedTimer);
        var self = this;
        this.codeWasCopiedTimer = setTimeout(function () { return self.codeWasCopied = false; }, 3000);
    };
    MiniCart = tslib_1.__decorate([
        Component
    ], MiniCart);
    return MiniCart;
}(Vue));
export default MiniCart;
